import api from './api';

export interface AppConfigs {
  evolution_instance?: string;
  whatsapp_number?: string;
  [key: string]: string | undefined;
}

export const configuracoesService = {
  getConfigs: async (): Promise<AppConfigs> => {
    const response = await api.get('/configuracoes');
    return response.data;
  },

  saveConfigs: async (configs: AppConfigs): Promise<void> => {
    await api.post('/configuracoes', configs);
  },

  testWhatsApp: async (): Promise<{ message?: string; error?: string }> => {
    const response = await api.post('/configuracoes/test-whatsapp');
    return response.data;
  },

  getWhatsAppStatus: async (): Promise<{ state: string }> => {
    const response = await api.get('/configuracoes/status');
    return response.data;
  },

  createEvolutionInstance: async (instanceName: string) => {
    const response = await api.post('/configuracoes/evolution/create', { instanceName });
    return response.data;
  },

  getEvolutionQrCode: async () => {
    const response = await api.get('/configuracoes/evolution/connect');
    return response.data;
  },

  getEvolutionPairingCode: async (phoneNumber: string) => {
    const response = await api.post('/configuracoes/evolution/pairing-code', { phoneNumber });
    return response.data;
  },

  disconnectEvolution: async () => {
    const response = await api.post('/configuracoes/evolution/disconnect');
    return response.data;
  },

  resetEvolutionConfig: async () => {
    const response = await api.post('/configuracoes/evolution/reset');
    return response.data;
  }
};
